export function init() {
  //console.log("nav init");

  //  console.log("init nav menu");
  jQuery("header .search").on("click", ".action", function (e) {
    jQuery("header .search").toggleClass("active");
  });

  jQuery(".headerpopup").on("click", function (e) {
    e.stopPropagation();
  });
  jQuery("header").on("click", ".haspopup", function (e) {
    //  console.log("haspopup clicked: ")
    if (!jQuery(".hamburger:hidden").length) {
      e.stopPropagation();
      //   console.log("click toggle active")
      jQuery(this).toggleClass("active");
    }
  });

  jQuery("header").on("mouseover", ".haspopup", function (e) {
    // console.log("header haspopup mouseover: ", jQuery(this).find("input[name='username']").length);
    if (jQuery(".hamburger:hidden").length) {
      jQuery(".haspopup").removeClass("active");
      jQuery(this).addClass("active");
    }
  });

  jQuery("header").on("mouseout", ".headerpopup", function () {
    // console.log("header popup mouseout input username? ", jQuery(this).find("input[name='username']").length);
    if (
      jQuery(this).find("input[name='username']").length &&
      jQuery(this).find("input[name='username']").is(":focus")
    ) {
      // this is the login form, don't toggle active
      return;
    }
    jQuery(this).parents(".active").removeClass("active");
  });

  jQuery("#nav > .wp-block-group").on("mouseover", function () {
    //add container to the outer block group
    jQuery(this)
      .find(".wp-block-group__inner-container > .wp-block-group")
      .addClass("container");
    jQuery("#nav")
      .find("img")
      .each(function () {
        if (jQuery(this).attr("data-src") != "") {
          jQuery(this).attr("src", jQuery(this).attr("data-src"));
          jQuery(this).attr("srcset", jQuery(this).attr("data-srcset"));
          jQuery(this).attr("data-src", "");
        }
      });

    jQuery("#nav > .wp-block-group").removeClass("active");
    jQuery(this).addClass("active");
  });

  jQuery(".wp-block-group__inner-container > .wp-block-group").on(
    "mouseout",
    function () {
      jQuery(this).parents(".wp-block-group.active").removeClass("active");
    },
  );

  jQuery(".grid-list li").remove();
  jQuery("<li class='filterstoggle'></li>").appendTo(".grid-list");
  jQuery(".grid-list").on("click", ".filterstoggle", function () {
    jQuery(".filters").toggleClass("open");
    jQuery(".filterstoggle").toggleClass("open");
  });

  jQuery(".hamburger").on("click", function (e) {
    jQuery("#body").toggleClass("navopen");
    // if (jQuery(".navbar-container").hasClass("open")) {
    //     scrollTo("#page");
    // }
  });

  jQuery(".navbar-container #nav >.wp-block-group").on("click", function (e) {
    jQuery("#nav")
      .find("img")
      .each(function () {
        if (jQuery(this).attr("data-src") != "") {
          jQuery(this).attr("src", jQuery(this).attr("data-src"));
          jQuery(this).attr("srcset", jQuery(this).attr("data-srcset"));
          jQuery(this).attr("data-src", "");
        }
      });

    if (jQuery("#body").hasClass("navopen")) {
      e.stopPropagation();
      var thisopen = jQuery(this).hasClass("open") ? true : false;

      jQuery("#nav >.wp-block-group").removeClass("open");

      if (!thisopen) {
        jQuery(this).addClass("open");
      }
    }
  });

  //jQuery(".search-action").clone().appendTo(jQuery("#main-navigation"));
}
